<template>
    <div class="cherry-canvas">
           <canvas id="mycanvas"></canvas> 
    </div>
</template>

<style lang="less" scoped>
 .cherry-canvas{
     position:fixed;
     top:0;
     bottom:50%;
     left:0;
     right:0;
     opacity: 0.6;
     /*background:rgba(0, 0, 0, 0.3);*/
     z-index:1;
 }
</style>

<script>
    export default {
        data() {
            return {
            }
        },
        props: ['config'],
        mounted(){
            this.cherryfn();
        },
        methods: {
            cherryfn (){
                /*樱花下落效果*/
                    function rnd(n, m) {
                        return Math.floor(Math.random() * (m - n) + n);
                    };
                    // rnd (n,m) => Math.floor(Math.random()*(m-n) + n);
                    function d2a(n) {
                        return n * Math.PI / 180;
                    };
                    // d2a (n) => Math.PI / 180;

                    //在画布中生成樱花：
                    var oC = document.getElementById("mycanvas");
                    var gd = oC.getContext("2d");
                    var maxW = document.documentElement.clientWidth;
                    var maxH = document.documentElement.clientHeight;
                        oC.width = maxW;
                        oC.height = maxH;
                    var arr = [];
                    var frames = 0;
                    for (var i = 0; i < 10; i++) {
                        arr.push({
                            "left": rnd(0, maxW),
                            "top": -10,
                            "deg": rnd(-10, 10),
                            "scale": rnd(8, 12)
                        });
                    }
                    var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
                    var _image = new Image();
                    var iceWH = 2;
                    _image.src = "//p0.meituan.net/wedding/ebb25d54face3db7b5ee4224cf2578992964.png%402048w_2048h_0e_1l%7Cwatermark%3D0";
                    _image.onload = function () {
                        loop();
                    }
                    var loop = function () {
                        if (frames % 5 == 0) {
                            next();
                        }
                        if (frames > 100) {
                            frames = 0
                        }
                        frames++;
                        gd.clearRect(0, 0, oC.width, oC.height);
                        gd.save();

                        for (var i = 0; i < arr.length; i++) {
                            var h = 0.3 * arr[i].scale;
                            arr[i].left = arr[i].left + Math.tan(d2a(arr[i].deg)) * h;
                            arr[i].top = arr[i].top + h;

                            //若已在画面外则删除
                            if (arr[i].left < 0 || arr[i].left > maxW || arr[i].top > maxH) {
                                arr.splice(i--, 1);
                                continue;
                            }

                            // var width_i = arr[i].scale;
                            // var ra = gd.createRadialGradient(arr[i].left, arr[i].top, width_i/4, arr[i].left, arr[i].top, width_i);
                            // ra.addColorStop(0, "rgba(255,255,255,1)");
                            // ra.addColorStop(1, "rgba(255,255,255,0.1)");
                            // gd.fillStyle = ra;
                            // gd.beginPath();
                            gd.drawImage(_image, arr[i].left, arr[i].top, iceWH * arr[i].scale, iceWH * arr[i].scale);
                            //gd.arc(arr[i].left, arr[i].top, width_i, 0, 2*Math.PI);
                            //gd.fill();
                        }
                        //gd.restore();
                        raf(loop);
                    }

                    // setInterval(function(){
                    //      loop(); 
                    // }, 17);

                    //不断增加新的樱花
                    function next() {
                        arr.push({
                            "left": rnd(0, maxH),
                            "top": -10,
                            "deg": rnd(-10, 10),
                            "scale": rnd(8, 12)
                        });
                    };

                    next();
            }
        }

    }

</script>


// WEBPACK FOOTER //
// cherry.vue?f0961e32